import { Container } from '@material-ui/core';
import { useAccount } from 'modules/account/hooks/useAccount';
// import { t } from 'modules/i18n/utils/intl';
import { Button } from 'modules/uiKit/Button';
import { Wallet } from '../Wallet';
import { useHeaderStyles } from './HeaderStyles';
import { Logo } from 'modules/layout/components/Logo';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
// import { NavLink } from 'react-router-dom';
import {
  SelectChainDialog,
  useDialogState,
} from 'modules/layout/components/Header/components/SelectChainDialog';

const lindSpaceStyles = { marginLeft: 8 };

export const Header = () => {
  const { isConnected, handleConnect, loading,
    chainId
  } = useAccount();
  const classes = useHeaderStyles();
  const renderedWallet = <Wallet />;
  const {
    opened: openedSelectChainDialog,
    close: closeSelectChainDialog,
  } = useDialogState();

  const baseEnv = process.env.REACT_APP_BASE_ENV;

  const renderedDesktop = (
    <>
      {!isConnected && (
        <Button onClick={handleConnect} className={classNames(classes.connect)}
                loading={loading}>
          {/* {t('header.connect')} */}
        </Button>
      )}
      {isConnected && (
        <div>
          {renderedWallet}
        </div>
      )}
    </>
  );


  return (
    <header className={classNames(classes.root)}>
      <Container className={classes.container} maxWidth={false}>
        <SelectChainDialog
          isOpen={openedSelectChainDialog}
          onClose={closeSelectChainDialog}
          currentChain={chainId}
        />
        <Box className={classes.navs}>
          <Logo />
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Button
            variant="text"
            style={lindSpaceStyles}
            activeClassName={classes.activeLink}
            className={classes.link}
            onClick={() => {
              window.open(baseEnv === "DEV" ?'https://testnets.opensea.io/collection/bitcoin-152':'', '_blank');
            }}
          >
            Opensea
          </Button>
          <Button
            variant="text"
            style={lindSpaceStyles}
            activeClassName={classes.activeLink}
            className={classes.link}
            onClick={() => {
              window.open(baseEnv === "DEV" ?'https://x.com/0xBitcoin_Pump':'', '_blank');
            }}
          >
            Uniswap
          </Button>
          <Button
            // component={NavLink}
            variant="text"
            style={lindSpaceStyles}
            activeClassName={classes.activeLink}
            className={classes.link}
            // to={'https://x.com/0xBitcoin_Pump'}
            onClick={() => {
              window.open('https://docs.bitcoin-pump.fun/', '_blank');
            }}
          >
            Docs
          </Button>
          {/* window.open('https://x.com/0xBitcoin_Pump', '_blank'); */}
          {renderedDesktop}
        </Box>

      </Container>
    </header>
  );
};
